import { gql } from "apollo-angular";

export const PAGINATION_FRAGMENT = gql`
  fragment PaginationFragment on PageInfo {
    page
    pageSize
    total
  }
`;
